import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, lastValueFrom, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { DTO } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private http: HttpClient) {}

  async getFileById(id: number | string): Promise<DTO.DownloadDTO | null> {
    try {
      return await firstValueFrom(
        this.http.get<DTO.DownloadDTO>(`files/${id}`).pipe(
          catchError((error) => {
            console.error(`Erro ao buscar arquivo com ID ${id}:`, error);
            return of(null);
          })
        )
      );
    } catch {
      return null;
    }
  }

  async loadFile(id: number | string): Promise<string | undefined> {
    try {
      const file = await this.getFileById(id);

      if (!file) {
        console.warn('Nenhum arquivo encontrado.');
        return undefined;
      }

      return file.base64;
    } catch (error) {
      console.error('Erro ao carregar o arquivo:', error);
      return undefined;
    }
  }

  async getMultiplesFiles(id?: number): Promise<DTO.UploadDTO[] | null> {
    try {
      const path = id ? `files/user/${id}` : 'files/user';
      return await firstValueFrom(
        this.http.get<DTO.UploadDTO[]>(path).pipe(
          catchError((error) => {
            console.error(
              `Erro ao buscar arquivos do usuário ID ${id}:`,
              error
            );
            return of(null);
          })
        )
      );
    } catch {
      return null;
    }
  }

  async deleteFile(id: number | string): Promise<DTO.UserDTO | null> {
    try {
      return await firstValueFrom(
        this.http
          .delete<DTO.UserDTO>(`files/${id}`)
          .pipe(catchError(() => of(null)))
      );
    } catch {
      return null;
    }
  }

  async sendOneFile(
    file: File,
    isAvatar: boolean,
    imageID?: number
  ): Promise<DTO.UserDTO | null> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('isAvatar', isAvatar ? 'true' : 'false');
    formData.append('id', imageID != null ? imageID.toString() : '');

    try {
      return await firstValueFrom(
        this.http
          .put<DTO.UserDTO>('files/upload', formData)
          .pipe(catchError(() => of(null)))
      );
    } catch {
      return null;
    }
  }

  async sendMultiplesFiles(files: File[]): Promise<boolean> {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files', file, file.name);
    });

    try {
      await firstValueFrom(
        this.http
          .post('files/uploads', formData)
          .pipe(catchError(() => of(false)))
      );
      return true;
    } catch {
      return false;
    }
  }
}
